@if (iconSet()) {
    <div tourAnchor="deal.dashboard.series.summary">
    <div class="series-summary widget-card card bg-white min-h-[160px] mt-4">
        <div class="header-section grid grid-cols-9 gap-x-3" data-cy="portfolioSeriesDetails">
          <div class="col-span-6 min-w-[0]">
            <div class="portfolio-name" data-cy="portfolioName">{{dealSummary()?.portfolioName}}</div>
            <div class="series-name" data-cy="seriesName">{{dealSummary()?.portfolioSeriesName}}</div>
          </div>
          <div class="col-span-2 min-w-[0]">
            <div class="inv-title text-right">Investment Status </div>
            <div class="inv-detail text-right break-words" data-cy="investmentStatus">{{dealSummary()?.realizationType}}
            </div>
          </div>
          <div class="col-span-1 min-w-[0]">
            <div class="inv-title text-right">Investment Type </div>
            <div class="inv-detail text-right break-words mb-2.5" data-cy="investmentType">
            {{dealSummary()?.investmentType}}</div>
          </div>
        </div>
        <div class="series-details grid grid-cols-2 gap-y-10 ml-4 lg:grid-cols-6 lg:gap-y-20 gap-x-[30px] py-5 md:px-[15px] md:gap-x-10 lg:gap-x-6 lg:ml-0"
          data-cy="seriesDetails">
          <div class="value-container">
            <div class="value text-center text-lg lg:text-2xl" data-cy="balanceValue">
              {{dealSummary()?.commitment |
            currencyFormat:dealSummary()?.portfolioCurrency:'Millions'}}</div>
            <div class="text-center text-md lg:text-lg">Commitments</div>
          </div>
          <div class="value-container">
            <div class="value text-center text-lg lg:text-2xl" data-cy="balanceValue">
              {{dealSummary()?.contributions |
            currencyFormat:dealSummary()?.portfolioCurrency:'Millions'}}</div>
            <div class="text-center text-md lg:text-lg">Contributions</div>
          </div>
          <div class="value-container">
            <div class="value text-center text-lg lg:text-2xl" data-cy="balanceValue">
              {{dealSummary()?.distributions |
            currencyFormat:dealSummary()?.portfolioCurrency:'Millions'}}</div>
            <div class="text-center text-md lg:text-lg">Distributions</div>
          </div>
          <div class="value-container">
            <div class="value text-center text-lg lg:text-2xl" data-cy="balanceValue">{{dealSummary()?.nav |
              currencyFormat:dealSummary()?.portfolioCurrency:'Millions'}}
            </div>
            <div class="text-center text-md lg:text-lg">NAV</div>
          </div>
          <div class="value-container">
            <div class="value text-center text-lg lg:text-2xl" data-cy="tvpiValue">{{dealSummary()?.tvpi |
              tvpiValueFormat}}
            </div>
            <div class="text-center text-md lg:text-lg">Investment TVPI</div>
          </div>
          <div class="value-container">
            <div class="value text-center text-lg lg:text-2xl" data-cy="irrValue">{{dealSummary()?.irr |
            irrValueFormat}}</div>
            <div class="text-center text-md lg:text-lg">Investment IRR</div>
          </div>
        </div>
    </div>
  </div>
  <div class="mt-4" tourAnchor="deal.dashboard.summary"
    data-cy="dealSummary">
    <div class="deal-summary widget-card card bg-white">
      <div class="header-section">
        <div class="flex flex-wrap">
          <h4 class="summary-text pl-0">Summary</h4>
        </div>
        <div class="summary-desc pt-3 md:min-h-24">
          @if (showSummary()) {
            <div>
              <div [innerHTML]="(this.dealSummaryText() ?? '') | safeHtml" #summaryElement
                class="short-desc text-md lg:text-lg lg:min-h-24" data-cy="summary">
              </div>
              @if (showMoreBtn()) {
                <div>
                  <a href="javaScript:;" class="view-more-btn" (click)="openModal()"
                  data-cy="viewMoreButton">View More</a>
                </div>
              }
            </div>
          } @else {
            <div class="text-md lg:text-lg">
              No summary available
            </div>
          }
        </div>
      </div>
      <div class="grid grid-cols-2 pt-10 gap-x-10 w-full">
        <div class="summary-details gap-y-10 md:gap-y-24 md:mr-4 lg:mr-0">
          <div class="pl-0 grid grid-cols-5 border-b border-medium-grey py-2">
            <div class="text-md lg:text-lg col-span-2">Investment Strategy</div>
            <div class="value text-md lg:text-lg col-span-3" data-cy="investmentStrategyText">
            {{dealSummary()?.strategy}}</div>
          </div>
          <div class="pl-0 grid grid-cols-5 border-b border-medium-grey py-2">
            <div class="text-md lg:text-lg col-span-2">Vintage Year</div>
            <div class="value text-md lg:text-lg col-span-3" data-cy="vintageYearText">{{dealSummary()?.vintageYear}}
            </div>
          </div>
          @if (dealSummary()?.fundSize) {
            <div class="pl-0 grid grid-cols-5 border-b border-medium-grey py-2">
              <div class="text-md lg:text-lg col-span-2">Fund Size</div>
              <div class="value text-md lg:text-lg col-span-3" data-cy="fundSizeValue">
                {{dealSummary()?.fundSize |
                currencyFormat:dealSummary()?.currency:'Millions'}}
              </div>
            </div>
          }
          <div class="pl-0 grid grid-cols-5 border-b border-medium-grey py-2" data-cy="dealCurrencyText">
            <div class="text-md lg:text-lg col-span-2">Currency</div>
            <div class="value currency-text col-span-3">
              {{dealSummary()?.currency ?? '-'}}
              {{(dealSummary()?.currency ?? '') | currencySymbol:true}}
            </div>
          </div>
        </div>
        <div class="manager">
          @if (sponsors()?.length > 0) {
            <div class="text-md md:text-lg py-2 border-b border-medium-grey">Investment Manager{{sponsors()?.length > 1 ? 's' : ''}}</div>
              <div class="pl-0 grid grid-cols-[auto_1fr] items-center gap-x-4 gap-y-2 py-2" data-cy="dealManagerText">
                @for (sponsor of displayedSponsors(); track sponsor) {
                  <div class="manager-logo md:max-w-[175px] lg:max-w-[240px]">
                      <img src="{{sponsor.logoUrl}}" class="md:max-w-[175px] lg:max-w-[240px]" alt="Investment Manager Logo"
                        data-cy="investmentManagerLogo">
                    </div>
                    <div class="manager-name text-md md:text-lg" data-cy="investmentManagerText">
                    {{sponsor.name}}</div>
                }
              </div>
              @if (hasMoreSponsors()) {
                <div>
                  <a href="javaScript:;" class="view-all-managers-btn" (click)="openSponsorsModal()"
                  data-cy="viewAllManagersButton">View More</a>
                </div>
              }
            }
          </div>
        </div>
      </div>
  </div>
  }